/**
 * Le NOM de la personne dans l'espace — **avec les règles d'Argalis Core, jamais une copie.**
 *
 * Constaté par le PO le 2026-09-15 : l'accueil disait « Bonjour dany.varlet » et
 * l'en-tête « dany.varlet » — la partie locale de l'adresse, parce qu'un compte
 * d'espace naît sans nom. Le serveur sert désormais `first_name` / `last_name`
 * (ceux du compte, sinon ceux de la fiche de l'espace) ; ce module les met en forme.
 *
 * ⭐ Deux règles, déjà écrites ailleurs et APPELÉES ici :
 *  · l'accueil dit le PRÉNOM seul, via `formatFirstName` (une majuscule par partie
 *    d'un prénom composé, le reste en minuscules) ;
 *  · l'en-tête appelle `getDisplayName` d'Argalis Core avec la limite de SON
 *    en-tête (`UserHeaderMenu`) : « Julie FONTAINE », sinon « Julie F. », sinon
 *    « Julie », sinon le prénom tronqué.
 * Réécrire l'une ou l'autre ici donnerait deux règles qui divergeraient au premier
 * ajustement ; `lespaceNommeLaPersonneCommeArgalis.test.ts` compare au rendu de Core.
 *
 * Sans prénom ni nom connus, le nom affiché servi (`display_name`) est rendu TEL
 * QUEL : aucun nom n'est inventé à partir d'une adresse.
 */
import type { PortalUser } from '@/hooks/usePortalMe.types'
import { formatFirstName } from '@/lib/formatters'
import { getDisplayName } from '@/lib/user-utils'

/** La limite de l'en-tête d'Argalis Core (`UserHeaderMenu`) : même coin, même règle. */
export const LIMITE_DE_LEN_TETE = 20

const propre = (valeur?: string | null): string => (valeur ?? '').trim()

/** « Bonjour {prénom} » : le prénom seul, en forme ; sinon le nom affiché servi. */
export function prenomDAccueil(user: PortalUser): string {
    const prenom = propre(user.first_name)
    return prenom ? formatFirstName(prenom) : user.display_name
}

/** Le nom du menu de compte, en haut à droite, dans les trois espaces. */
export function nomDEnTete(user: PortalUser): string {
    const prenom = propre(user.first_name)
    const nom = propre(user.last_name)
    if (!prenom && !nom) return user.display_name
    // `email` n'est lu par `getDisplayName` qu'en l'absence de prénom ET de nom —
    // cas écarté juste au-dessus : il ne sert qu'à satisfaire sa signature.
    return getDisplayName(
        { firstName: prenom ? formatFirstName(prenom) : null, lastName: nom || null, email: user.display_name },
        LIMITE_DE_LEN_TETE,
    )
}
